var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-application vuetify-wrapper d-block mt-4",
      attrs: { "data-test": "custom-invoices" },
    },
    [
      _vm.loading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.error && !_vm.dialog
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "error",
                outlined: "",
                "data-test": "custom-invoice-error",
              },
            },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.context.create_block_reason
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "warning",
                outlined: "",
                "data-test": "custom-invoice-block-reason",
              },
            },
            [_vm._v(_vm._s(_vm.context.create_block_reason.message))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mb-4",
          attrs: {
            color: "primary",
            disabled:
              _vm.loading ||
              _vm.busy ||
              !_vm.context.recipient ||
              Boolean(_vm.context.create_block_reason),
            "data-test": "custom-invoice-create",
          },
          on: {
            click: function ($event) {
              return _vm.open(null, false)
            },
          },
        },
        [_vm._v("Individuelle Rechnung erstellen")]
      ),
      _vm._v(" "),
      _c("v-simple-table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Status")]),
            _c("th", [_vm._v("Referenz")]),
            _c("th", [_vm._v("Rechnungsdatum")]),
            _c("th", [_vm._v("Netto")]),
            _c("th", [_vm._v("MwSt.")]),
            _c("th", [_vm._v("Brutto")]),
            _c("th", [_vm._v("Aktionen")]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.context.invoices, function (invoice) {
              return _c(
                "tr",
                {
                  key: invoice.id,
                  attrs: {
                    "data-test": "custom-invoice-row",
                    "data-invoice-id": invoice.id,
                  },
                },
                [
                  _c("td", [_vm._v(_vm._s(_vm.statusLabels[invoice.status]))]),
                  _c("td", [_vm._v(_vm._s(invoice.reference))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        invoice.invoice_date.split("-").reverse().join(".")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.money(invoice.net_amount)))]),
                  _c("td", [_vm._v(_vm._s(_vm.money(invoice.vat_amount)))]),
                  _c("td", [_vm._v(_vm._s(_vm.money(invoice.gross_amount)))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            small: "",
                            disabled: _vm.busy,
                            "data-test": "custom-invoice-view",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.open(invoice, true)
                            },
                          },
                        },
                        [_vm._v("Ansehen")]
                      ),
                      _vm._v(" "),
                      invoice.can_edit
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                small: "",
                                disabled: _vm.busy,
                                "data-test": "custom-invoice-edit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.open(invoice, false)
                                },
                              },
                            },
                            [_vm._v("Bearbeiten")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      invoice.can_delete
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                small: "",
                                color: "error",
                                disabled: _vm.busy,
                                "data-test": "custom-invoice-delete",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.selected = invoice
                                  _vm.deleteDialog = true
                                },
                              },
                            },
                            [_vm._v("Löschen")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      invoice.can_transfer
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                small: "",
                                disabled: _vm.busy,
                                "data-test": "custom-invoice-transfer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.transition(invoice, "transfer")
                                },
                              },
                            },
                            [_vm._v("An Apobilanz übertragen")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      invoice.can_retrieve
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                small: "",
                                disabled: _vm.busy,
                                "data-test": "custom-invoice-retrieve",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.transition(invoice, "retrieve")
                                },
                              },
                            },
                            [_vm._v("Aus Apobilanz zurückholen")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            _vm._v(" "),
            !_vm.loading && _vm.context.invoices.length === 0
              ? _c("tr", [
                  _c("td", { attrs: { colspan: "7" } }, [
                    _vm._v("Noch keine individuellen Rechnungen."),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            scrollable: "",
            "max-width": "850",
            "content-class": "v-application",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _vm.dialog
            ? _c("custom-invoice-form", {
                attrs: {
                  invoice: _vm.selected,
                  recipient: _vm.selected
                    ? _vm.selected.recipient
                    : _vm.context.recipient,
                  readonly: _vm.readonly,
                  busy: _vm.busy,
                  error: _vm.error,
                },
                on: {
                  close: function ($event) {
                    _vm.dialog = false
                  },
                  save: _vm.save,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("delete-confirmation-dialog", {
        attrs: {
          message:
            "Diesen Rechnungsentwurf löschen? Die Referenz bleibt dauerhaft reserviert.",
        },
        on: { "confirm-deletion": _vm.remove },
        model: {
          value: _vm.deleteDialog,
          callback: function ($$v) {
            _vm.deleteDialog = $$v
          },
          expression: "deleteDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }